import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0 pt-5" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder fs-3 mb-1" }
const _hoisted_5 = { class: "text-muted mt-1 fw-bold fs-7" }
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "card-body py-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_download_excel = _resolveComponent("download-excel")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(
              "tabla.serviciosColectivosSolicitadosListadoCompletoCompleto.titulo"
            )), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(
              "tabla.serviciosColectivosSolicitadosListadoCompleto.numeroSolicitudes",
              {
                numero: _ctx.serviciosListado?.length ?? 0,
              }
            )), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
          style: {"width":"300px"},
          placeholder: _ctx.$t('tabla.buscador.placeholder')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_download_excel, {
          data: _ctx.serviciosListado,
          labels: _ctx.csvLabels,
          fields: _ctx.csvFields,
          name: _ctx.csvName
        }, {
          default: _withCtx(() => [
            _createElementVNode("button", _hoisted_7, [
              _createElementVNode("i", {
                class: "fas fa-file-excel fs-3",
                title: 
                _ctx.$t(
                  'tabla.serviciosColectivosSolicitadosListadoCompleto.boton.imprimir'
                )
              
              }, null, 8, _hoisted_8)
            ])
          ]),
          _: 1
        }, 8, ["data", "labels", "fields", "name"])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_table, {
        data: _ctx.serviciosListado,
        style: {"width":"100%"},
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListadoCompleto.cabecera.fecha'
            )
          ,
            prop: "createdOn",
            formatter: _ctx.toLocaleDateString,
            sortable: "",
            width: "110"
          }, null, 8, ["label", "formatter"]),
          (_ctx.isAdmin)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                label: _ctx.$t('tabla.familias.cabecera.comarca'),
                prop: "nombreComarca",
                sortable: "",
                "min-width": "150"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.comarca?.nombre), 1)
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t('tabla.serviciosProgramadosListadoCompleto.cabecera.servicio')
          ,
            prop: "servicioProgramado.nombre",
            sortable: "",
            "min-width": "150"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_router_link, {
                to: _ctx.calculateLink(scope.row),
                class: "nav-link text-active-primary me-6",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.servicioProgramado?.nombre), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListadoCompleto.cabecera.responsable'
            )
          ,
            prop: "responsable",
            sortable: "",
            "min-width": "150"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListadoCompleto.cabecera.telefono'
            )
          ,
            sortable: "",
            prop: "telefonoFamilia",
            width: "120"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: 
            _ctx.$t(
              'tabla.serviciosColectivosSolicitadosListadoCompleto.cabecera.menor'
            )
          ,
            sortable: "",
            prop: "menoresNombres"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('tabla.profesionales.cabecera.estado'),
            prop: "estado",
            sortable: "",
            width: "160",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                class: "ml-2",
                type: 
                scope.row.estado === _ctx.FormularioEstado.incorporado
                  ? 'success'
                  : scope.row.estado === _ctx.FormularioEstado.listaDeEspera
                  ? 'warning'
                  : [
                      _ctx.FormularioEstado.noApto,
                      _ctx.FormularioEstado.rechazado,
                      _ctx.FormularioEstado.realizadorPorError,
                    ].includes(scope.row.estado)
                  ? 'danger'
                  : ''
              
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(`formularios.estado.${scope.row.estado}`)), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            width: "50",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                type: "text",
                onClick: ($event: any) => (_ctx.handleEdit(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t(
                  "tabla.serviciosColectivosSolicitadosListadoCompleto.fila.ver"
                )), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ])
  ]))
}